//Generated File 
export default class EditedObjectSourceType{
	static readonly AlwaysCreateNew = `AlwaysCreateNew`;
	static readonly FromField = `FromField`;
}
